var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0,
};

site.device = {
	// Check if device is a touch device
	isTouch: function () {
		try {
			document.createEvent('TouchEvent');
			return true;
		} catch (e) {
			return false;
		}
	},
};

site.accessibility = {
	init: function () {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	},
};

site.owl = {
	// Shorthand to init owlcarousel
	init: function (id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	},
};

site.svg = {
	init: function () {
		$('img[src*=".svg"]').each(function () {
			var $img = $(this);
			$.get($img.attr('src'), function (data) {
				var $svg = $(data).find('svg').removeAttr('xmlns:a');
				$.each($img.prop('attributes'), function () {
					$svg.attr(this.name, this.value);
				});
				$img.replaceWith($svg);
			}, 'xml');
		});
	},
};

site.frontpage = {
	init: function () {
		site.owl.init('.box_extras_items .images', {
			loop: true,
			dots: true,
			nav: false,
			autoHeight: true,
			autoplay: true,
			autoplayTimeout: 8000,
			smartSpeed: 700,
			margin: 0,
			items: 1,
			lazyLoad: true,
		});
		site.owl.init('#main .ummaeli-vidskiptavina .items', {
			loop: false,
			nav: true,
			navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
			dots: false,
			autoplay: false,
			smartSpeed: 700,
			items: 1,
		});


		$('#mainmenu .level1 a[href*=\\#], .footerRow a[href*=\\#]').on('click', function (e) {
			e.preventDefault();
			location.hash = this.hash;
			site.frontpage.smoothScrollingTo(location.hash);

			if ($('body').hasClass('mobilemenu-open')) {
				$('body').removeClass('mobilemenu-open');
			}
		});
		$(document).ready(function () {
			site.frontpage.smoothScrollingTo(location.hash);
		});

	},
	smoothScrollingTo: function (target) {
		if (target) {
			// Replace since we don't have correct ids on items, use class instead
			const stripTarget = target.replace('#', '.');
			const elementById = document.querySelector(stripTarget);
			if (elementById) {
				elementById.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'});
			}
		}
	},
};


// Run all the inits \o/
$(function () {
	$.each(site.inits, function (i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();
	//site.svg.init();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', 'main').each(function () {
		$(this).attr('allowfullscreen', '').wrap('<div class="video" style="max-width:' + $(this).width() + 'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', 'main').wrap('<div class="table-responsive"></div>');
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
